import React from 'react'
// icons
import {FaReact} from 'react-icons/fa'
import {GoRuby} from 'react-icons/go'
import {ImCss3} from 'react-icons/im'
import {SiPostgresql} from 'react-icons/si'
import {AiFillHtml5} from 'react-icons/ai'
import {DiJava} from 'react-icons/di'
import {ImDatabase} from 'react-icons/im'
import {DiJavascript1} from 'react-icons/di'

import Joey from '../../img/joey.jpg'
//hook for checking if an el is in viewport
import useIsInViewport from 'use-is-in-viewport'

function About() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>

		<div  className="About" id="about">
			<h2>About Me...</h2>
			<img alt="Joseph Guzzardo, a man with thick medium length brown hair swooped to the side, brown eyes, and fair skin, wearing a block button down smiling in front of a bush with pink flowers." src={Joey}/>
			<p>I'm <strong>Joseph</strong>, a Full-Stack Engineer in NYC.  Welcome to my site. </p>
			<p>I am an adaptable fast pace learner, using or creating whatever tools necessary to see my ideas come to life. I graduated from <strong>St. John's University</strong> obtaining my Bachelors of Science majoring in <strong>Computer Science</strong>. <br/>
			Following my Graduation I went on to attended the <strong>Flatiron School</strong> where I learned Full-Stack software development in 15 weeks. There I worked alongside fellow developers both in-person and remotely to build several applications that you can check out below.
			</p>
			<br/>
			<b className="use">Some of the technologies I use are...</b>
			<ul className="technologies">
				<li><FaReact className="icon"/>React</li>
				<li><DiJavascript1 className="icon"/>JavaScript</li>
				<li><GoRuby className="icon"/>Ruby on Rails</li>
				<li><AiFillHtml5 className="icon"/>HTML</li>
				<li><ImCss3 className="icon"/>SCSS/CSS</li>
				<li><ImDatabase className="icon"/>RESTful API</li>
				<li><SiPostgresql className="icon"/>Postsql | SQLite</li>
				<li><DiJava className="icon"/>Java</li>
			</ul>
		</div>
		</div>
	  )
}

export default About